import { render, staticRenderFns } from "./TurnsForm.html?vue&type=template&id=4e44d11e&external"
import script from "./TurnsForm.ts?vue&type=script&lang=ts&external"
export * from "./TurnsForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports